﻿package com.mgacreative.hotelru.feature.crm.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.core.notifications.domain.NotificationManager
import com.mgacreative.hotelru.core.notifications.domain.ChannelType
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlinx.datetime.*

data class CrmGuest(
    val id: String, 
    val name: String, 
    val phone: String,
    val totalStays: Int, 
    val lastStayDate: String, // YYYY-MM-DD
    val birthDate: String // MM-DD
)

data class Campaign(
    val id: String,
    val title: String,
    val segment: String,
    val sentCount: Int,
    val openRate: Double,
    val clickRate: Double
)

class CrmViewModel(
    private val notificationManager: NotificationManager
) : ViewModel() {

    private val _guests = MutableStateFlow<List<CrmGuest>>(emptyList())
    
    private val _campaigns = MutableStateFlow<List<Campaign>>(emptyList())
    val campaigns: StateFlow<List<Campaign>> = _campaigns.asStateFlow()

    private val _successMessage = MutableStateFlow<String?>(null)
    val successMessage: StateFlow<String?> = _successMessage.asStateFlow()

    val returningGuests: StateFlow<List<CrmGuest>> = MutableStateFlow(emptyList())

    init {
        loadData()
        // Run daily checks (Simulated for Acceptance Criteria)
        checkBirthdays()
    }

    private fun loadData() {
        _guests.value = emptyList()
        (returningGuests as MutableStateFlow).value = emptyList()
        _campaigns.value = emptyList()
    }

    // Acceptance Criteria: Doğum günü hatırlatmaları doğru tarihte otomatik tetikleniyor
    private fun checkBirthdays() {
        viewModelScope.launch {
            // Getting today's MM-DD for simulation (Assume 07-19)
            val todayMmDd = "07-19" 
            
            val birthdayGuests = _guests.value.filter { it.birthDate == todayMmDd }
            for (guest in birthdayGuests) {
                // Send SMS to Guest
                notificationManager.dispatch(
                    userId = guest.id,
                    recipient = guest.phone,
                    title = "Doğum Gününüz Kutlu Olsun!",
                    body = "İyi ki doğdunuz ${guest.name}! Bir sonraki konaklamanızda size özel %15 indiriminiz var.",
                    targetChannels = listOf(ChannelType.SMS)
                )
            }
        }
    }

    // Acceptance Criteria: Kampanya bir segmentteki tüm misafirlere doğru şekilde gönderiliyor
    fun sendCampaign(title: String, segment: String) {
        viewModelScope.launch {
            val targetGuests = when (segment) {
                "SADIK" -> _guests.value.filter { it.totalStays >= 2 }
                "KAYIP" -> _guests.value.filter { it.lastStayDate < "2026-01-01" } // Haven't visited in 6 months
                else -> _guests.value
            }

            if (targetGuests.isEmpty()) {
                _successMessage.value = "Hata: Bu segmente uyan misafir bulunamadı."
                return@launch
            }

            // Simulate sending to each guest
            for (guest in targetGuests) {
                notificationManager.dispatch(
                    userId = guest.id,
                    recipient = guest.phone,
                    title = title,
                    body = "Size özel kampanya: $title",
                    targetChannels = listOf(ChannelType.EMAIL, ChannelType.SMS)
                )
            }

            // Record Campaign
            val newCampaign = Campaign(
                id = "c_${kotlin.random.Random.nextInt()}",
                title = title,
                segment = segment,
                sentCount = targetGuests.size,
                openRate = 0.0,
                clickRate = 0.0
            )
            
            _campaigns.value = listOf(newCampaign) + _campaigns.value
            _successMessage.value = "Kampanya başarıyla ${targetGuests.size} kişiye gönderildi!"
        }
    }

    fun clearMessage() {
        _successMessage.value = null
    }
}


